


















import Vue from 'vue';

export default Vue.extend({
  props: {
    threshold: {
      type: Number,
      default: 50,
    },
    value: Boolean,
    height: {
      type: Number,
      default: 300,
    },
    width: {
      type: Number,
      default: 300,
    },
  },

  data() {
    return {
      isDrawing: false,
      clickX: [] as number[],
      clickY: [] as number[],
      clickDrag: [] as boolean[],
      size: 300,
    };
  },

  computed: {
    canvas() {
      return (): HTMLCanvasElement => this.$refs.canvas as HTMLCanvasElement;
    },

    context() {
      return () => this.canvas().getContext('2d');
    },

    container(): HTMLElement {
      return this.$refs.container as HTMLElement;
    },
  },

  watch: {
    width: {
      immediate: true,
      handler() {
        this.updateCanvas();
      },
    },

    height: {
      immediate: true,
      handler() {
        this.updateCanvas();
      },
    },
  },

  mounted() {
    this.updateCanvas();
  },

  methods: {
    updateCanvas() {
      if (!this.canvas()) return;

      const context = this.context();

      if (!context) return;

      let size = this.width;

      if (this.height < this.width) {
        size = this.height;
      }

      context.canvas.width = size;
      context.canvas.height = size;
      this.size = size;
    },

    clear() {
      this.clickX = [];
      this.clickY = [];
      this.clickDrag = [];

      const context = this.context();

      if (!context) return;

      context.clearRect(0, 0, context.canvas.width, context.canvas.height); // Clears the canvas

      this.$emit('input', this.clickX.length >= this.threshold);
    },

    onMouseDown(evt: MouseEvent) {
      const rect = this.canvas().getBoundingClientRect();
      const mouseX = evt.clientX - rect.left;
      const mouseY = evt.clientY - rect.top;

      this.isDrawing = true;

      this.addClick(mouseX, mouseY);
    },

    onTouchStart(evt: TouchEvent) {
      const rect = this.canvas().getBoundingClientRect();
      const mouseX = evt.touches[0].clientX - rect.left;
      const mouseY = evt.touches[0].clientY - rect.top;

      this.isDrawing = true;

      this.addClick(mouseX, mouseY);
    },

    onMouseMove(evt: MouseEvent) {
      const rect = this.canvas().getBoundingClientRect();
      const mouseX = evt.clientX - rect.left;
      const mouseY = evt.clientY - rect.top;

      if (this.isDrawing) {
        this.addClick(mouseX, mouseY, true);
      }
    },

    onTouchMove(evt: TouchEvent) {
      const rect = this.canvas().getBoundingClientRect();
      const mouseX = evt.touches[0].clientX - rect.left;
      const mouseY = evt.touches[0].clientY - rect.top;

      if (this.isDrawing) {
        this.addClick(mouseX, mouseY, true);
      }
    },

    onMouseUpLeave() {
      this.isDrawing = false;

      this.canvas().toBlob(blob => {
        this.$emit('ready', { image: this.canvas().toDataURL(), blob });
      });
    },

    addClick(x: number, y: number, dragging: boolean = false) {
      this.$emit('input', this.clickX.length >= this.threshold);

      this.clickX.push(x);
      this.clickY.push(y);
      this.clickDrag.push(dragging);

      this.drawLast();
    },

    drawLast() {
      const index = this.clickX.length - 1;
      const context = this.context();

      if (!context) return;

      context.strokeStyle = '#000';
      context.lineJoin = 'round';
      context.lineWidth = 5;

      context.beginPath();

      if (this.clickDrag[index] && index) {
        context.moveTo(this.clickX[index - 1], this.clickY[index - 1]);
      } else {
        context.moveTo(this.clickX[index] - 1, this.clickY[index]);
      }
      context.lineTo(this.clickX[index], this.clickY[index]);
      context.stroke();

      context.closePath();
    },
  },
});
